import { Box, ColorOptions, IconNew as Icon, TextNew, useWindowDimensions } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { Animated, Easing } from 'react-native'
import NavItem from '../../comps/NavItem'
import { footerStrings, staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import { ENABLE_JIOPAY_FOR_CONSUMER } from '../../util/util'
import { handleLogin, htmlRouting } from '../Nav'
import { styles } from './styles'

interface NavMobileProps {
  onPress: () => void
}

const NavMob: FC<NavMobileProps> = ({ onPress }: NavMobileProps) => {
  const navigate = useNavigation().navigate
  const [showProducts, setProductsVisibility] = useState(false)

  const themedStyle = styles

  // useLayoutEffect(() => {
  //   setProductsVisibility(true)
  // }, [])

  const handleRouting = (id: string): void => {
    onPress()
    if (id === 'contact' || id === 'about-us' || id === 'jio-pay-consumers' || id === 'partner-program') {
      navigate(id)
    }
    if (id === 'signin') {
      handleLogin()
    }
    if (id === 'signup') {
    }

    htmlRouting(id)
  }
  const isFocused = useIsFocused()
  const screenW = useWindowDimensions()

  const [animatedValue] = useState<any>(new Animated.Value(0))

  const animation = Animated.timing(animatedValue, {
    toValue: 1,
    duration: 300,
    easing: Easing.linear,
    useNativeDriver: true,
  })
  const startAnimation = () => {
    animation.start()
  }

  const animate = {
    transform: [
      {
        translateX: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [0.9 * screenW, 0],
        }),
      },
    ],
  }

  useEffect(() => {
    startAnimation()
  }, [isFocused, startAnimation])

  const handleOnClose = () => {
    Animated.timing(animatedValue, {
      toValue: 0,
      duration: 300,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(() => onPress())
  }
  return (
    <Animated.View style={[animate]}>
      <Box {...themedStyle.navbar}>
        <Box {...themedStyle.cancel}>
          <Box
            {...themedStyle.arrowRight}
            onPress={handleOnClose}
            backgroundColor={colors.HOVER_SOLID as ColorOptions}
            underlayColor={'TRANSPARENT'}>
            <Icon id={'CLOSE'} size={16} color={colors.JIO_PRIMARY_ALPHA as ColorOptions} />
          </Box>
        </Box>
        <Box h={1} bg={'SEPERATOR'} />
        <Box overflow={'scroll'} flex={1}>
          <NavItem
            id="Products"
            title={staticStrings.products}
            close={onPress}
            onPress={() => setProductsVisibility(!showProducts)}
            showArrow={true}
            expanded={showProducts}
          />
          <NavItem id="partner-program" title={staticStrings.partnerProgram} onPress={handleRouting} />
          <NavItem id="contact" title={staticStrings.contact} onPress={handleRouting} />
          <NavItem id="about-us" title={footerStrings.about} onPress={handleRouting} />
          <NavItem
            id="jio-pay-consumers"
            title={staticStrings.jiopayForConsumers}
            onPress={handleRouting}
            hide={!ENABLE_JIOPAY_FOR_CONSUMER}
          />
          <NavItem hide id="signup" title={staticStrings.signup} onPress={handleRouting} />
        </Box>
        <Box p={24} borderTopWidth={1} borderTopColor={'SEPERATOR'}>
          <Box
            bg={colors.HIGHLIGHT as ColorOptions}
            borderRadius={6}
            justifyContent="center"
            height={48}
            width={'100%'}
            onPress={() => handleRouting('signin')}>
            <TextNew
              fontFamily="jiotype-medium"
              fontSize={12}
              textAlign="center"
              color="WHITE"
              title={staticStrings.signin}
            />
          </Box>
        </Box>
      </Box>
    </Animated.View>
  )
}

export default NavMob
